import { Button } from '@mui/material';
import { ErrorPage } from 'components/system/ErrorPage';
import LeftColorIcon from 'components/system/Icons/LeftColorIcon';
import { createContext, ReactNode, useContext, useState } from 'react';
import { DASHBOARD_ROUTE } from 'routes/constants';

interface IError {
  code: number;
  title: string;
  message: ReactNode;
  action?: ReactNode;
}

interface IErrorContext {
  error: IError | null;
  setError: (error: IError | null) => void;
}

export const ErrorContext = createContext<IErrorContext>({
  error: null,
  setError: (error: IError | null) => error,
});

export const useError = () => useContext(ErrorContext);

export const ErrorProvider = ({ children }: { children: ReactNode }) => {
  const [error, setError] = useState<IError | null>(null);

  return (
    <ErrorContext.Provider value={{ error, setError }}>
      {!!error ? (
        <ErrorPage
          action={
            <Button
              variant="text"
              color="primary"
              onClick={() => {
                window.location.href = DASHBOARD_ROUTE;
              }}
            >
              <LeftColorIcon sx={{ width: '14px', height: '14px', mr: 1 }} />
              <span>Back to dashboard</span>
            </Button>
          }
          {...error}
        />
      ) : (
        children
      )}
    </ErrorContext.Provider>
  );
};
